import {
  createContext,
  useContext,
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  fetchAuthSession,
  getCurrentUser,
  signOut as amplifySignOut,
} from 'aws-amplify/auth';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'authenticated' | 'unauthenticated'
  const [email, setEmail] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const session = await fetchAuthSession();
      if (session?.tokens?.idToken) {
        const user = await getCurrentUser();
        setEmail(
          user?.signInDetails?.loginId ??
            session.tokens.idToken.payload?.email ??
            null,
        );
        setStatus('authenticated');
        return;
      }
    } catch {
      // no valid session
    }
    setEmail(null);
    setStatus('unauthenticated');
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signOut = useCallback(async () => {
    await amplifySignOut();
    setEmail(null);
    setStatus('unauthenticated');
  }, []);

  return (
    <AuthContext.Provider value={{ status, email, refresh, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
}
